'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _dec,_desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const ex=require('pulsar-utils/dist-es6/ex');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const{MinDeviationThreshold:MinDeviationThreshold,MaxDeviationThreshold:MaxDeviationThreshold,MinFatigueThreshold:MinFatigueThreshold,MaxFatigueThreshold:MaxFatigueThreshold}=require('../../../../../dist-es6/server/domain/group');let

SetThresholdModalController=(_dec=






























































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=function(_BaseController){_inherits(SetThresholdModalController,_BaseController);_createClass(SetThresholdModalController,null,[{key:'$inject',get:function(){return['$modalInstance','$scope','$timeout','socketService','organizationDefaultsService','uncaughtErrorHandler','uiCommandFactory','resolvedParameters']}}]);function SetThresholdModalController($modalInstance,$scope,$timeout,socketService,organizationDefaultsService,uncaughtErrorHandler,uiCommandFactory,resolvedParameters){_classCallCheck(this,SetThresholdModalController);var _this=_possibleConstructorReturn(this,_BaseController.call(this,uncaughtErrorHandler));_this._$modalInstance=$modalInstance;_this._$scope=$scope;_this._$timeout=$timeout;_this._onThresholdSet=resolvedParameters.onThresholdSet;_this._group=resolvedParameters.group;_this._fatigueThreshold=ex(_this._group.fatigueThreshold).otherwise(resolvedParameters.defaultFatigueThreshold);_this._deviationThreshold=ex(_this._group.deviationThreshold).otherwise(resolvedParameters.defaultDeviationThreshold);_this._socketService=socketService;_this._setOrganizationThresholdsCommand=function(f,d){return organizationDefaultsService.setOrganizationThresholds(f,d)};_this.setThresholdCommand=uiCommandFactory.makeForModal($modalInstance,function(){return _this._setThreshold()});_this.selectedDeviationThreshold=_this._deviationThreshold;_this.availableDeviationThresholds=_.range(MinDeviationThreshold,MaxDeviationThreshold+1);_this._$scope.$watch('controller.selectedDeviationThreshold',function(newDeviationThreshold){if(newDeviationThreshold===_this._deviationThreshold){return}_this._deviationThreshold=newDeviationThreshold});return _this}SetThresholdModalController.prototype.
_setThreshold=function(){var ref=_asyncToGenerator(function*(){
if(this.isOrganization){
yield this._setOrganizationThresholdsCommand(this._fatigueThreshold,this._deviationThreshold);
}else{
yield this._socketService.sendAndWaitForResponse('SetGroupThresholds',{
groupId:this._group.id,
fatigueThreshold:this._fatigueThreshold,
deviationThreshold:this._deviationThreshold});

}

yield this._onThresholdSet(this._group.id);

return ModalSubmissionResult.Close();
});function _setThreshold(){return ref.apply(this,arguments)}return _setThreshold}();SetThresholdModalController.prototype.

onCancel=function onCancel(){
this._$modalInstance.dismiss();
};_createClass(SetThresholdModalController,[{key:'isOrganization',get:function(){return this._group.isSpecialGroupContainingWholeOrg===!0}},{key:'fatigueThreshold',get:function(){return this._fatigueThreshold},set:function(fatigueThreshold){this._fatigueThreshold=fatigueThreshold}},{key:'deviationThreshold',get:function(){return this._deviationThreshold},set:function(deviationThreshold){this._deviationThreshold=deviationThreshold}}]);return SetThresholdModalController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_setThreshold',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_setThreshold'),_class.prototype)),_class));


module.exports=SetThresholdModalController;
//# sourceMappingURL=setThresholdModalController.js.map
